export enum OnfidoStatusEnum {
  UNAVAILABLE = 'UNAVAILABLE',
  NOT_STARTED = 'NOT_STARTED',
  INVITE_SENT = 'INVITE_SENT',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  WAITING_FOR_RESULT = 'WAITING_FOR_RESULT',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}
